const init = () => {
  document.querySelectorAll('.js-overlay-open-btn')
      .forEach((el) => el.addEventListener('click', openOverlay));
  document.querySelectorAll('.js-overlay-close-btn')
      .forEach((el) => el.addEventListener('click', closeOverlay));
};

const openOverlay = (event) => {
  const targetId = event.currentTarget.getAttribute('data-target');
  const overlayEl = document.getElementById(targetId);
  if (overlayEl) {
    overlayEl.classList.remove('is-hidden');
  }
};

const closeOverlay = (event) => {
  const targetId = event.currentTarget.getAttribute('data-target');
  const overlayEl = document.getElementById(targetId);
  if (overlayEl) {
    overlayEl.classList.add('is-hidden');
  }
};

export default {init};
